import React, { useContext, useState } from 'react';
import { Button } from 'antd';

import { SalesOrderLine } from '@totem/components/salesOrders/list/types';
import OrgHierarchySelector from '@totem/components/ui_components/widgets/hierarchySelector/orgHierarchySelector';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { ObjectReference } from '@totem/types/common';
import { SALES_ORDERS_ENDPOINT } from '@totem/utilities/endpoints';

const styles = {
  saveButton: { marginTop: '1rem' },
};

export interface Props {
  salesOrderLine: SalesOrderLine;
  onSaved: () => void;
}

const SalesOrderLineHierarchyEditPanel = ({
  salesOrderLine,
  onSaved,
}: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [organization, setOrganization] = useState<ObjectReference>({
    id: salesOrderLine.organization?.id ?? '',
    name: salesOrderLine.organization?.name ?? '',
  });
  const [region, setRegion] = useState<ObjectReference>({
    id: salesOrderLine.region?.id ?? '',
    name: salesOrderLine.region?.name ?? '',
  });
  const [building, setBuilding] = useState<ObjectReference>({
    id: salesOrderLine.building?.id ?? '',
    name: salesOrderLine.building?.name ?? '',
  });

  const handleHierarchyChange = (
    org: ObjectReference,
    rgn: ObjectReference,
    bldg: ObjectReference,
  ) => {
    setOrganization(org);

    setRegion(rgn);

    setBuilding(bldg);
  };

  const handleSave = () => {
    setIsSaving(true);

    fetch(`${SALES_ORDERS_ENDPOINT}/${salesOrderLine.id}/hierarchy`, {
      method: 'PUT',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({ organization, region, building }),
    }).then(() => {
      setIsSaving(false);

      onSaved();
    });
  };

  return (
    <>
      <OrgHierarchySelector
        showLabels
        labelPosition={'left'}
        showOrganization={permissions.internal.hasPermissions(userProfile)}
        showRegions={false}
        showBuildings
        showControlSystems={false}
        defaultOrganizationId={salesOrderLine.organization?.id}
        defaultRegionId={salesOrderLine.region?.id}
        defaultBuildingId={salesOrderLine.building?.id}
        onChange={handleHierarchyChange}
      />
      <Button
        type="primary"
        onClick={handleSave}
        loading={isSaving}
        style={styles.saveButton}
      >
        Save Location
      </Button>
    </>
  );
};

export default SalesOrderLineHierarchyEditPanel;
